import isEven from './isEven';
export default function isOdd(value) {
    return !isEven(value);
}
